import { Box, Container, Paper, Typography } from '@mui/material';
import BlockOutlinedIcon from '@mui/icons-material/BlockOutlined';
import { BotaoVoltarPdv } from '../../components/botao-voltar-pdv';

/**
 * Exibida quando a empresa NÃO contratou o módulo do modo acessado (totem,
 * tablet, delivery, etc.). A mensagem vem pronta do backend (inclui o nome do
 * modo) — ver `erros.modoIndisponivel` + enforcement em `plugins/tenant.ts`.
 */
export function ModoIndisponivelPage({ mensagem }: { mensagem?: string }): JSX.Element {
  return (
    <Container maxWidth="sm" sx={{ pt: 8 }}>
      <Paper variant="outlined" sx={{ p: 4, textAlign: 'center' }}>
        <Box sx={{ mb: 2 }}>
          <BlockOutlinedIcon sx={{ fontSize: 64, color: 'text.disabled' }} />
        </Box>
        <Typography variant="h5" gutterBottom>
          Cardápio indisponível
        </Typography>
        <Typography color="text.secondary">
          {mensagem ?? 'Este modo do cardápio não está disponível. Verifique com o suporte Sischef.'}
        </Typography>

        <BotaoVoltarPdv />
      </Paper>
    </Container>
  );
}
